import React, { useState } from "react";
import CheckIfUserExists from "./CheckIfUserExists";
import Login from "./Login";
import Register from "./Register";

export default ({ codeInfo, handleGoBack, handleLoginSuccess }) => {
  const [state, setState] = useState("validate-email");
  const [email, setEmail] = useState("");

  const handleUserLoggedIn = () => {
    handleLoginSuccess();
  };

  console.log("Login or register", email);

  switch (state) {
    case "validate-email":
      return (
        <CheckIfUserExists
          codeInfo={codeInfo}
          handleUserExists={() => setState("login")}
          handleUserNotExists={() => setState("register")}
          handleGoBack={handleGoBack}
          email={email}
          onSetEmail={(email) => setEmail(email)}
        />
      );
    case "login":
      return (
        <Login
          onSetState={(s) => setState(s)}
          email={email}
          handleGoBack={() => setState("validate-email")}
          handleLoginSuccess={handleLoginSuccess}
          onLoggedIn={handleUserLoggedIn}
        />
      );
    case "register":
      return (
        <Register
          onSetState={(s) => setState(s)}
          subjectInfo={codeInfo}
          handleGoBack={() => setState("validate-email")}
          email={email}
          onLoggedIn={handleUserLoggedIn}
        />
      );
  }
};
